/**
 * What a tool call's chat line is titled: the tool's `labelKey` (backend
 * `AgentTool.labelKey` — a Tolgee key in namespace `Assistant` whose English
 * text is the key, e.g. "Searching companies") translated into the UI
 * language, or the tool's raw name for a tool without one (`labelKey` null)
 * and for history stored before labels existed (no `labelKey` at all).
 *
 * The keys arrive at runtime and there is deliberately no central list of
 * them here: each package that labels a tool adds its own key to the
 * `Assistant` namespace, and the backend's `agentToolsBuild.spec.ts` checks
 * that every labelled tool's key exists in `en.json`. Hence the dynamic-key
 * cast below (the `PdsSyncReviewModal` `fc.label` precedent) — with
 * English text == key, a key Tolgee does not know yet still renders its
 * English text instead of failing.
 */
import type { TranslationKey } from "@msys/tolgee";
import { useTranslate } from "@tolgee/react";
import React from "react";
import type { AgentToolTitle } from "./agentChatAdapter.js";

export function useAgentToolTitle(): AgentToolTitle {
  const { t } = useTranslate(["Assistant"]);
  return React.useCallback<AgentToolTitle>(
    ({ name, labelKey }) =>
      labelKey && labelKey.trim() !== ""
        ? t(labelKey as TranslationKey<"Assistant">, { ns: "Assistant" })
        : name,
    [t]
  );
}
